let inject = ['$http', 'ngAuthSettings', '$q', 'AuthTokenFactory', 'SessionService', '$httpParamSerializerJQLike'];

class SharedService {
    
    constructor($http, ngAuthSettings, $q, AuthTokenFactory, SessionService, $httpParamSerializerJQLike) {
        this.ngAuthSettings = ngAuthSettings;
        this.$q = $q;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.AuthTokenFactory = AuthTokenFactory;
        this.$http = $http;
        this.SessionService = SessionService;
        this.globals = {};
        this.constants = {
            cities: '/crm/proyectos/search-city',
            thirds: '/terceros/terceros/search-terceros',
            items: '/items/items/search-items'
        };
    }

    getInitialParams(userId) {
        let promiseParams = [];

        if (__env.clientName !== 'laskin') {
            let globalCategories = this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categories,
                cache: false
            });

            promiseParams.push(globalCategories);
        }

        let categoriesMenu = this.$http({
            method: 'GET',
            url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categoriesMenu + '?userId=' + userId,
            cache: false
        });

        promiseParams.push(categoriesMenu);

        if (__env.clientName !== 'laskin') {
            let banners = this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getBanners,
                cache: false
            });
            promiseParams.push(banners);
        }

        let params = this.$http({
            method: 'POST',
            url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getParams,
            cache: false,
            data: this.$httpParamSerializerJQLike({'userId': userId, 'slug': __env.clientName, 'origen':'b2b'}),
            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        });

        promiseParams.push(params);
        //[globalCategories, categoriesMenu, banners, params]
        return this.$q.all(promiseParams).then(data => data);
    }

    sendMailContact(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.mailProductRecommended,
                cache: false,
                data: this.$httpParamSerializerJQLike(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateDespachoPedido(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateDespachoPedido,
                cache: false,
                data: this.$httpParamSerializerJQLike(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    sendNewsletterForm(newsletterDataForm) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.mailNewsletter,
                cache: false,
                data: this.$httpParamSerializerJQLike(newsletterDataForm),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getParams(userId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getParams,
                cache: false,
                data: this.$httpParamSerializerJQLike({'userId': userId}),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getSearchProductsGlobal(searchText, limit, userId, cartId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.searchProductAutocomplete + searchText + '&limit=' + limit + '&userId=' + userId + '&cartId=' + cartId,
                cache: false
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getGlobalCategories() {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categories,
                cache: false
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getBanners() {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getBanners,
                cache: false
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }
    getLocations(){
      return this.$q((resolve, reject) => {
        this.$http({
          method: 'GET',
          url: this.ngAuthSettings.apiServiceBaseUri + '/location/get-operating-centers-coverage-by-owner',
          cache: false,
          headers: {'Content-Type': 'application/json'}
        }).then(response => {
          resolve(response);
        }).catch(reason => {
          reject(reason);
        });
      });
    }

    setDeliveryLocation(params) {
      let cartId = this.SessionService.get('cartId') || '';
      return this.$q((resolve, reject) => {
        this.$http({
          method: 'POST',
          url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.setCoverageDelivery + '?cartId=' + cartId,
          cache: false,
          data: this.$httpParamSerializerJQLike(params),
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        }).then(response => {
          this.SessionService.put('cartId', response.data.data.cardId);
          resolve(response.data);

        }).catch(reason => {
          reject(reason);
        });
      });
    }


    getTestimonies(itemId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.testimonies + itemId,
                cache: false
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getCategoriesMenu(userId) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categoriesMenu + '?userId=' + userId,
                cache: false
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getAllSimple(pageSize, pageNumber, search, param) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.constants[param] + '?pageSize=' + pageSize + '&pageNumber=' + pageNumber + '&searchText=' + search,
                cache: false
                // data : {
                //   'pageSize' : pageSize,
                //   'pageNumber' : pageNumber,
                //   'searchText' : search
                // }
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    saveUserLogued(user) {
        // let token = btoa(user.userId + ':' + new Date());
        // this.AuthTokenFactory.setToken('auth-user', token);
        // this.userSaved = user;

        this.globals = {
            currentUser: user
        };

        try {
            let operatingCenters = user.operatingCenters;
            this.globals.currentClient = {};
            if (operatingCenters.length === 1) {
                this.globals.currentClient = {};
                if (!user.isSeller) {
                    if(user.seller.nombre){
                        this.globals.currentClient.seller = user.seller;
                    }
                    this.globals.currentClient.operatingCenter = {
                        'id': operatingCenters[0].id,
                        'name': operatingCenters[0].name,
                        "address": operatingCenters[0].address,
                        "location": operatingCenters[0].location,
                        "code": operatingCenters[0].code,
                    };
                    // Third
                    this.globals.currentClient.third = {
                        'id': operatingCenters[0].thirdId,
                        'name': operatingCenters[0].thirdName,
                        'documentNumber': user.thirdDocumentNumber
                    };
                    // Contact
                    this.globals.currentClient.contact = {
                        'id': operatingCenters[0].contactId,
                        'name': operatingCenters[0].contactName,
                    };
                }
            }
            else {
                if (!user.isSeller) {
                    this.globals.currentClient = {};
                    if(user.seller.nombre){
                        this.globals.currentClient.seller = user.seller;
                    }
                    // Third
                    this.globals.currentClient.third = {
                        'id': operatingCenters[0].thirdId,
                        'name': operatingCenters[0].thirdName,
                        'documentNumber': user.thirdDocumentNumber
                    };
                    // Contact
                    this.globals.currentClient.contact = {
                        'id': operatingCenters[0].contactId,
                        'name': operatingCenters[0].contactName,
                    };
                }
            }
        }
        catch (e) {
        }

        //avatar
        this.globals.currentClient.avatar = user.avatar;

        this.SessionService.branches = this.globals.currentUser.operatingCenters;
        this.SessionService.put('globals', this.globals);
    }

    partialConsultThird() {
        let token = this.AuthTokenFactory.getToken('auth-third');
        if (token) {
            let thirdId = atob(token);
            thirdId = thirdId.split(':')[0];
            return thirdId;
        } else {
            return null;
        }
    }

    saveThirdSelected(third) {
        let token = btoa(third.id + ':' + new Date());
        this.AuthTokenFactory.setToken('auth-third', token);
        if (third.branchSelected) {
            let branch = btoa(third.branchSelected.id + ':' + new Date());
            this.AuthTokenFactory.setToken('auth-third-branch', branch);
        }
        this.thirdSelected = third;
    }

    clearThird() {
        this.AuthTokenFactory.setToken('auth-third');
        this.AuthTokenFactory.setToken('auth-third-branch');
        this.thirdSelected = {};
    }

    partialConsultUser() {
        let token = this.AuthTokenFactory.getToken('auth-user');
        if (token) {
            let userId = atob(token);
            userId = userId.split(':')[0];
            return userId;
        } else {
            return null;
        }
    }

    getUserData() {
        return this.$q((resolve, reject) => {
            if (this.userSaved.userId) {
                resolve(this.userSaved);
            } else {
                let userInSave = this.AuthTokenFactory.getToken('auth-user');
                if (!userInSave) return reject();
                let user = atob(userInSave);
                user = user.split(':')[0];
                this.$http({
                    method: 'GET',
                    url: this.ngAuthSettings.apiServiceBaseUri + '/terceros/terceros/get-info-user?userId=' + user,
                    cache: false
                }).then((response) => {
                    this.userSaved = response.data;
                    resolve(response.data);
                }, (reason) => {
                    reject(reason);
                });
            }
        });
    }

    getThirdData() {
        return this.$q((resolve, reject) => {
            let thirdSelected = this.AuthTokenFactory.getToken('auth-third');
            if (!thirdSelected) return reject();
            let third = atob(thirdSelected);
            third = third.split(':')[0];
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + '/terceros/terceros/get-tercero?terceroId=' + third,
                cache: false
            }).then((response) => {
                let branch = this.AuthTokenFactory.getToken('auth-third-branch');
                if (branch) {
                    let branchSelected = atob(branch);
                    branchSelected = branchSelected.split(':')[0];
                    response.data.branchSelected = response.data.sucursales.filter(val => val.id === branchSelected)[0];
                }
                this.thirdSelected = response.data;
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getFeaturedProducts(third) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + '/items/items/search-items?pageSize=' + 10 + '&pageNumber=' + 1 + '&searchText=&terceroId=' + third + '&tipoFiltro=1',
                // url: this.ngAuthSettings.apiServiceBaseUri + '/item-info/ver-productos-destacados?userId=' + this.thirdSelected.id,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getCompanyData() {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + '/adminComponentes/companies?slug=' + __env.clientName,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getOcasionalInformation(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getOcasionalInformation,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    validateNumberIdUnusedHeader(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.validateNumberId,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    updateInfoClientSelected(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updateInfoClientSelected,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    validateEmailUnusedHeader(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.validateEmail,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    validateEmail(email) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/login/validate-email',
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike({'email': email})
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }

    getLocationBySearchText(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.locationBySearchText,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }

    getContactByIdentificationNumber(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.thirdBySearchText,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }

    getThirdBySearchText(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.thirdBySearchText,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }

    validateThirdDocument(document) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + '/terceros/terceros/validar-tercero',
                cache: false,
                data: {
                    'terceroDocumento': document
                }
            }).then(response => {
                let resolveData = parseInt(response.data);
                resolve(resolveData);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    logoutUser() {
        return this.$q((resolve, reject) => {
            try {
                this.AuthTokenFactory.setToken('auth-third');
                this.AuthTokenFactory.setToken('auth-user');
                this.AuthTokenFactory.setToken('auth-third-branch');
                this.AuthTokenFactory.setToken('auth-cart');
                this.userSaved = {};
                this.thirdSelected = {};
                this.cart = {};
                resolve();
            } catch (n) {
                reject();
            }

        });
    }


    getCMSBanners(pageName,ad=0) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getCMS + "?pageName=" + pageName +'&ad=' + ad,
                cache: false
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {
                reject(reason);
            });
        });
    }

    getSecondaryBranch(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getSucursalesSecundarias,
                cache: false,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then(response => {
                resolve(response.data);
            }).catch(reason => {

                reject(reason);
            });
        });
    }

    setOperatingCenter(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.setClientOperatingCenter,
                data: $.param(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    setModalidadPago(data){
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.updatePaymentMethod,
                data: $.param(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    assignWarehouseBasketCode(data){
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.assignWarehouseBasketCode,
                data: $.param(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

    verifyVolumePurchaseBasket(data){
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.verificarVolumenCompraCanasta,
                data: $.param(data),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                cache: false
            }).then(function (response) {
                resolve(response.data);
            }, function (reason) {
                reject(reason);
            });
        });
    }

}

SharedService.$inject = inject;

export default SharedService;



/** WEBPACK FOOTER **
 ** ./www/components/shared/shared.service.js
 **/